<template>
  <div :class="['navbar-area', { 'is-sticky': isSticky }]">
    <div class="parix-nav">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <router-link class="navbar-brand as-logo" to="/">
            <img src="../assets/images/as-logo-w-o-slogan.png" alt="logo" />
          </router-link>

          <div
            class="navbar-toggler"
            @click="active = !active"
            :aria-pressed="active ? 'true' : 'false'"
            :class="{ active: active }"
          >
            <span class="icon-bar top-bar"></span>
            <span class="icon-bar middle-bar"></span>
            <span class="icon-bar bottom-bar"></span>
          </div>

          <div class="collapse navbar-collapse" :class="{ show: active }">
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link to="/#despre-noi" class="nav-link" @click="closeMenu">Despre noi</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/#serviciile-noastre" class="nav-link" @click="closeMenu">Servicii</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/#metoda-atelierului" class="nav-link" @click="closeMenu">Mod de lucru</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/#clientii-nostri" class="nav-link" @click="closeMenu">Clienți</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/#echipa-noastra" class="nav-link" @click="closeMenu">Echipa</router-link>
              </li>

              <li class="nav-item">
                <router-link class="nav-link" to="/SoftOne" @click="closeMenu">
                  SoftOne <i class="bx bx-chevron-down"></i>
                </router-link>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/SoftOne#interfata" class="nav-link" @click="closeMenu">Interfață inovatoare</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/SoftOne#mobilitate" class="nav-link" @click="closeMenu">Mobilitatea Afacerilor</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/SoftOne#conectivitate" class="nav-link" @click="closeMenu">Conectivitate și colaborare</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/SoftOne#functionalitati" class="nav-link" @click="closeMenu">Funcționalități</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/SoftOne#testeaza" class="nav-link" @click="closeMenu">Testează</router-link>
                  </li>
                </ul>
              </li>

              <li class="nav-item d-lg-none">
                <router-link to="/#contact" class="nav-link" @click="closeMenu">Contactează-ne</router-link>
              </li>
            </ul>
          </div>

          <div class="others-option d-none d-lg-flex align-items-center">
            <div class="option-item">
              <router-link to="/#contact" class="default-btn" @click="closeMenu">
                <i class="flaticon-right"></i>&nbsp;&nbsp;Contactează-ne<span></span>
              </router-link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ASNavbar',
  data() {
    return {
      isSticky: false,
      active: false,
    };
  },
  methods: {
    closeMenu() {
      this.active = false;
    },
  },
  mounted() {
    const that = this;
    window.addEventListener('scroll', () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        that.isSticky = true;
      } else {
        that.isSticky = false;
      }
    });
  },
};
</script>

<style scoped>
.as-logo img {
  max-width: 300px;
  transition: max-width 0.3s ease;
}

.navbar-area .parix-nav .navbar .navbar-nav .nav-item {
  margin-left: 10px;
  margin-right: 10px;
}

.navbar-area .parix-nav .navbar .navbar-nav > .nav-item > a.nav-link {
  color: #221638;
  white-space: nowrap;
}

.navbar-area .parix-nav .navbar .navbar-nav > .nav-item > a.nav-link:hover,
.navbar-area .parix-nav .navbar .navbar-nav .nav-item .dropdown-menu .nav-item a.nav-link:hover {
  color: #ff5d22;
}

.navbar-area .parix-nav .navbar .navbar-nav .nav-item .dropdown-menu .nav-item a.nav-link {
  color: #221638;
  transition: 0.5s;
}

.navbar-area .parix-nav .navbar .others-option {
  margin-left: 20px;
}

.navbar-area .parix-nav .navbar .others-option .option-item .default-btn {
  white-space: nowrap;
  padding: 12px 20px 12px 40px;
  font-size: 15px;
}

.parix-nav .navbar .navbar-nav .nav-item a.nav-link.active {
  color: #221638;
}

/* Responsive styles for mobile */
@media only screen and (max-width: 991px) { /* Target devices smaller than large (Bootstrap's 'lg' breakpoint) */
  .as-logo img {
    max-width: 240px;
  }
  
  .navbar-area .parix-nav .navbar {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  /* Additional mobile-specific styles can be added here */
}
</style>